import {
  Autocomplete,
  FormHelperText,
  TextField,
  IconButton,
  Icon,
} from "@mui/material";
import { t } from "i18next";
import { get, isEqual } from "lodash";
import { useEffect, useRef, useState } from "react";
import "./BMXAutocomplate.scss";
import { ListItemButton } from "@material-ui/core";
import { useForm } from "react-final-form";

export default function BMXAutocomplente(props) {
  const {
    meta: { touched, error, submitError },
    input,
    currentValues,
    afterIcon,
    afterIconSize,
    afterIconClick,
    disabled,
    label,
    options = [],
    getOptionLabel = (option) => option?.label || "",
    renderOption,
    renderTags,
  } = props;

  const form = useForm();
  const [inputValue, setInputValue] = useState("");

  const prevCurrentValues = useRef();

  // Synchronizacja z zewnętrznymi wartościami (np. onChange z innego miejsca)
  useEffect(() => {
    if (!input.multiple) {
      if (
        !isEqual(
          get(currentValues, input?.name),
          get(prevCurrentValues.current, input?.name)
        )
      ) {
        input.onChange(get(currentValues, input?.name));
      }
      prevCurrentValues.current = currentValues;
    }
  }, [currentValues, input?.name, input.multiple, input]);

  const isError = () => {
    if (input?.multiple) {
      return !!((error || submitError) && touched && input?.value?.length <= 0);
    }
    return !!((error || submitError) && touched);
  };

  const onChange = (event, option) => {
    input.onChange(option);

    if (!input.multiple) {
      // Wyczyszczenie pola tekstowego po wyborze
      setInputValue(option ? getOptionLabel(option) : "");
    } else {
      setInputValue(""); // dla multiple też możesz wyczyścić, jeśli chcesz
    }
  };

  const handleInputChange = (event, newValue, reason) => {
    if (reason === "input") {
      setInputValue(newValue);
    }
  };

  const onBlur = () => {
    if (input?.multiple) {
      form.resetFieldState(input.name);
    } else {
      if (!input.value || typeof input.value === "string") {
        input.onChange(null);
      }
    }
  };

  useEffect(() => {
    if (!input?.multiple) {
      const newValue = input?.value ? getOptionLabel(input.value) : "";
      setInputValue(newValue);
    }
  }, [options]);

  const safeOptions = Array.isArray(options) ? options : [];

  const safeValue = input.multiple
    ? Array.isArray(input.value)
      ? input.value
      : []
    : typeof input.value === "object" && input.value !== null
    ? input.value
    : null;

  const conditionalProps = !input?.multiple
    ? {
        renderOption: (props, option) =>
          renderOption ? (
            renderOption(props, option)
          ) : (
            <ListItemButton {...props} onClick={(e) => onChange(e, option)}>
              {getOptionLabel(option)}
            </ListItemButton>
          ),
      }
    : {};

  return (
    <>
      <Autocomplete
        data-cy="autocomplete-select"
        {...props}
        {...conditionalProps}
        multiple={input?.multiple}
        options={safeOptions}
        value={safeValue}
        inputValue={inputValue}
        onInputChange={handleInputChange}
        onBlur={onBlur}
        name={input?.name}
        disableCloseOnSelect={Boolean(input?.multiple)}
        isOptionEqualToValue={(option, value) => option?.uuid === value?.uuid}
        onChange={onChange}
        noOptionsText={t("global:no_values")}
        getOptionLabel={getOptionLabel}
        renderTags={renderTags}
        className={`BMXAutocomplate ${input?.multiple ? "Multiple" : ""}`}
        renderInput={(params) => (
          <div className="InputArea">
            <TextField
              variant="standard"
              {...params}
              label={label}
              error={isError()}
            />
            {isError() && (
              <FormHelperText>
                <span className="error text">{error || submitError}</span>
              </FormHelperText>
            )}
            {afterIcon && (
              <IconButton
                size="small"
                disabled={disabled}
                onClick={afterIconClick}
                disableRipple={!afterIconClick}
              >
                <Icon style={{ fontSize: afterIconSize }}>{afterIcon}</Icon>
              </IconButton>
            )}
          </div>
        )}
      />
    </>
  );
}
